import React from 'react';

import type { Section } from '../../../../../models';
import { HEATING_OIL, UTILITY_CALCULATION_LISTBOX_OPTIONS } from '../../../../../constants';
import UtilitiesCalculation from '../../Utilities/UtilitiesCalculation/UtilitiesCalculation';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function HeatingOilCalculation({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesCalculation
      section={section}
      setSectionValues={setSectionValues}
      administrativeFeeField={HEATING_OIL.FIELD_NAME.ADMINSTRATIVE_FEE}
      listBoxField={HEATING_OIL.FIELD_NAME.FIXED_AMOUNT_CALCULATION}
      otherMethodDescriptionField={HEATING_OIL.FIELD_NAME.OTHER_METHOD_DESCRIPTION}
      otherMethodField={HEATING_OIL.FIELD_NAME.OTHER_METHOD}
      options={UTILITY_CALCULATION_LISTBOX_OPTIONS}
      utilityName="Heating oil"
    />
  );
}

HeatingOilCalculation.description =
  'Additional options for how they calculated and whether or not there an additional fee';

export default HeatingOilCalculation;
